import type { SidebarAccent, SidebarBadge } from './index';

// Glyph tint classes for each nav accent (component/sidebar/icon/color/*).
export const ACCENT_CLASS: Record<SidebarAccent, string> = {
  sky: 'text-sidebar-icon-sky',
  indigo: 'text-sidebar-icon-indigo',
  apricot: 'text-sidebar-icon-apricot',
  fuchsia: 'text-sidebar-icon-fuchsia',
};

// Status-pill text per badge kind (mapped to the Badge variants of the same name).
export const BADGE_LABEL: Record<SidebarBadge, string> = {
  new: 'New!',
  beta: 'Beta',
  soon: 'Soon',
};
